import React, { useEffect, useState } from "react";
import { PlusOutlined, DeleteOutlined, CloseOutlined, CheckOutlined, EditOutlined, PlusSquareFilled, ExpandAltOutlined } from '@ant-design/icons';
import { Modal, Col, Row, Table, Button, Form, FormInstance, Select, DatePicker, Space, Spin } from 'antd';
import dayjs from "dayjs";
import { AlignType } from 'rc-table/lib/interface';

import { errorMessage, mostrarInfo } from "../../../utils/messages";

import { disabledDate, hasText } from "../../../utils/utilsFunctions";
import { IPlanoBeneficio } from "../../../Interfaces/DadosPrevicInterfaces";
import { IDirigenteExcepcionalPlanoBeneficio } from "./InterfaceDirigenteExcepcional";
import { maskCNPB } from "../../../utils/maskFunctions";
import { pesquisarPlanosBeneficios } from "../../../services/apiCad";
import { hasPermissao, Papel } from "../../../auth/entidadeUsuario";

interface IProps {
  form: FormInstance<any>;
  dirigenteExcepcionalPlanosBeneficio: IDirigenteExcepcionalPlanoBeneficio[];
  setDirigenteExcepcionalPlanosBeneficio: React.Dispatch<React.SetStateAction<IDirigenteExcepcionalPlanoBeneficio[]>>;
  matriculaEfpc: string;
  manter?: number; // 1 : Inserir / 2 : Consultar / 3 : Editar;
  setDirigenteExcepcionalPlanoBeneficioTouched?: React.Dispatch<React.SetStateAction<boolean>>;
}

const { Option } = Select;

const DirigenteExcepcionalPlano = ({ form, dirigenteExcepcionalPlanosBeneficio, setDirigenteExcepcionalPlanosBeneficio, matriculaEfpc, manter }: IProps) => {
  const [loading, setLoading] = useState(false);
  const [tipLoading, setTipLoading] = useState("");

  const [estadoModal, setEstadoModal] = useState(1); // 1 : Modal em modo inserção / 2 : Modal em modo detalhe /  3 : Modal em modo edição
  const [exibirModalPlano, setExibirModalPlano] = useState(false);
  const [exibirPlano, setExibirPlano] = useState("none");
  const [exibirElementoAcaoAlteracao, setExibirElementoAcaoAlteracao] = useState("inline");
  const [dadosValidados, setDadosValidados] = useState(false);

  const [planosBeneficios, setPlanosBeneficios] = useState<IPlanoBeneficio[]>([]);

  const getPlanosBeneficios = async () => {
    try {
      setTipLoading("Buscando planos ...");
      setLoading(true);

      const linhaPorPagina = 10;

      const data = await pesquisarPlanosBeneficios(matriculaEfpc, linhaPorPagina, 0);
      console.log(data)
      setPlanosBeneficios(data);
    } catch (error: any) {
      errorMessage("Erro ao identificar os planos de benefícios da entidade selecionada.")
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (hasText(matriculaEfpc)) {
      getPlanosBeneficios();
    }
  }, [matriculaEfpc]);

  useEffect(() => {
    if (dirigenteExcepcionalPlanosBeneficio.length === 0) {
      setExibirPlano("none")
    } else {
      setExibirPlano("inline")
    }
  }, [dirigenteExcepcionalPlanosBeneficio]);


  useEffect(() => {
    if (manter === 2 || manter === 9) { // Detalhar
      setExibirElementoAcaoAlteracao("none");
    } else {
      setExibirElementoAcaoAlteracao("inline");
    }
  }, [manter]);


  useEffect(() => {
    if (estadoModal === 3) { // EM EDIÇÃO
      controleDaGrid("editar"); // CONFIGURA MODAL PARA ABRIR
    } else if (estadoModal === 2) { // EXIBIR DETALHES
      controleDaGrid("detalhar"); // CONFIGURA MODAL PARA ABRIR
    }
  }, [estadoModal])

  const controleDaGrid = (botao: string) => {
    if (!hasText(form.getFieldValue("matriculaEfpc"))) {
      mostrarInfo("Não é possível incluir novo plano", "Entidade não informada");
    } else if (!hasText(form.getFieldValue("dtInicioAtuacao"))) {
      mostrarInfo("Não é possível incluir novo plano", "Data de início da atuação não informada");
    } else if (form.getFieldValue("csObjeto") && form.getFieldValue("csObjeto") === 1) {
      mostrarInfo("Não é possível incluir plano", "Objeto entidade selecionado");
    } else {
      if (botao === "cancelar") {
        setExibirModalPlano(false);
        setExibirElementoAcaoAlteracao("inline");
      } else if (botao === "incluir") {
        setExibirModalPlano(false);
        setExibirElementoAcaoAlteracao("inline");
      } else {
        setExibirModalPlano(true);
        setExibirElementoAcaoAlteracao("none");
      }
    }

    if (manter === 2) { // Estamos no modo Detalhar
      setExibirElementoAcaoAlteracao("none");
    }
  };

  const validarPlanoBeneficio = () => {

    form
      .validateFields([
        "idDirExcepPlanoBeneficio",
        "nmPlanoBeneficio",
        "dtInicioPlano",
        "dtFimPlano",
      ])
      .then(() => {
        setDadosValidados(true);
        controleDaGrid("incluir");
        setDadosPlano();
      })
      .catch((error) => {
        if (!dadosValidados) {
          errorMessage("Campo obrigatório não preechido ou não validado");
        } else {
          errorMessage(error.message);
        }
        setDadosValidados(false);
      });

  };

  const setDadosPlano = () => {
    if (estadoModal === 3) { // ESTADO EDIÇÃO DE REGISTROS
      setDirigenteExcepcionalPlanosBeneficio(pre => {
        return pre.map(plano => {
          if (plano.emEdicao) {
            return ({
              idDirExcepPlanoBeneficio: estadoModal === 3 ? Number(form?.getFieldValue("idDirExcepPlanoBeneficio")) : -1,
              idDirExcepcional: Number(form?.getFieldValue("idDirExcepcional")),
              nmPlanoBeneficio: form?.getFieldValue("nmPlanoBeneficio"),
              cnpb: form?.getFieldValue("cnpb"),
              dtInicioAtuacao: form?.getFieldValue("dtInicioPlano") ? dayjs(form?.getFieldValue("dtInicioPlano")).format("YYYY-MM-DD") : "",
              dtFimAtuacao: form?.getFieldValue("dtFimPlano") ? dayjs(form?.getFieldValue("dtFimPlano")).format("YYYY-MM-DD") : "",
              statusReg: 1,
              touched: true,
              emEdicao: false,
            })
          } else {
            return plano
          }
        })
      });
    } else {
      setDirigenteExcepcionalPlanosBeneficio([
        ...dirigenteExcepcionalPlanosBeneficio,
        {
          idDirExcepPlanoBeneficio: estadoModal === 3 ? Number(form?.getFieldValue("idDirExcepPlanoBeneficio")) : -1,
          idDirExcepcional: Number(form?.getFieldValue("idDirExcepcional")),
          nmPlanoBeneficio: form?.getFieldValue("nmPlanoBeneficio"),
          cnpb: form?.getFieldValue("cnpb"),
          dtInicioAtuacao: form?.getFieldValue("dtInicioPlano") ? dayjs(form?.getFieldValue("dtInicioPlano")).format("YYYY-MM-DD") : "",
          dtFimAtuacao: form?.getFieldValue("dtFimPlano") ? dayjs(form?.getFieldValue("dtFimPlano")).format("YYYY-MM-DD") : "",
          statusReg: 1,
          touched: true,
          emEdicao: false,
        },
      ]);
    }
    limpaDados();
    setEstadoModal(1); // SETA O MODAL PARA INCLUSÃO (MODO PADRÃO).
  }

  const limpaDados = () => {
    form.resetFields([
      "idDirExcepPlanoBeneficio",
      "nmPlanoBeneficio",
      "dtInicioPlano",
      "dtFimPlano",
      "dtFimPlanoNaBase",
    ]);
  }

  const setFieldsDetalharEditar = (IDirigenteExcepcionalPlanoBeneficio: IDirigenteExcepcionalPlanoBeneficio) => {
    form.setFieldsValue({
      "idDirExcepPlanoBeneficio": IDirigenteExcepcionalPlanoBeneficio.idDirExcepPlanoBeneficio ? IDirigenteExcepcionalPlanoBeneficio.idDirExcepPlanoBeneficio : -1,
      "cnpbPlanoBeneficio": IDirigenteExcepcionalPlanoBeneficio.cnpb ? IDirigenteExcepcionalPlanoBeneficio.cnpb : '',
      "nmPlanoBeneficio": IDirigenteExcepcionalPlanoBeneficio.nmPlanoBeneficio,
      "dtInicioPlano": IDirigenteExcepcionalPlanoBeneficio.dtInicioAtuacao ? dayjs(IDirigenteExcepcionalPlanoBeneficio.dtInicioAtuacao) : undefined,
      "dtFimPlano": IDirigenteExcepcionalPlanoBeneficio.dtFimAtuacao ? dayjs(IDirigenteExcepcionalPlanoBeneficio.dtFimAtuacao) : undefined,
      "dtFimPlanoNaBase": IDirigenteExcepcionalPlanoBeneficio.dtFimAtuacao ? dayjs(IDirigenteExcepcionalPlanoBeneficio.dtFimAtuacao) : undefined,
    });
  }

  const columns = [
    {
      // width: 200,
      key: "1",
      title: "Plano de Benefício",
      dataIndex: "",
      render: (IPlano: IDirigenteExcepcionalPlanoBeneficio) => <>{maskCNPB(IPlano?.cnpb)} - {IPlano?.nmPlanoBeneficio?.toUpperCase()}</>,
    },
    {
      // width: 200,
      key: "2",
      title: "Data Inicial",
      dataIndex: "",
      render: (IPlano: IDirigenteExcepcionalPlanoBeneficio) => <>{dayjs(IPlano.dtInicioAtuacao).format("DD/MM/YYYY")}</>,
    },
    {
      // width: 200,
      key: "3",
      title: "Data Final",
      dataIndex: "",
      render: (IPlano: IDirigenteExcepcionalPlanoBeneficio) => <>{IPlano?.dtFimAtuacao ? dayjs(IPlano.dtFimAtuacao).format("DD/MM/YYYY") : undefined}</>,
    },
    {
      key: "9",
      title: "Opções",
      dataIndex: "",
      align: 'center' as AlignType,
      render: (IPlano: IDirigenteExcepcionalPlanoBeneficio) => (
          <Space style={{justifyContent: 'center'}}>
            <div style={{ display: manter === 2 || manter === 9 ? "inline" : "none" }}>
              <ExpandAltOutlined
                title="Detalhar"
                style={{ color: "blue", marginLeft: 12 }}
                onClick={() => {
                  setEstadoModal(2); // SET O MODO DETALHAR
                  setFieldsDetalharEditar(IPlano);
                }}
              />
            </div>

            <div style={{ display: manter === 1 ? "inline" : exibirElementoAcaoAlteracao }}>
              <EditOutlined
                title="Editar"
                style={{ color: "blue", marginLeft: 12, display: (IPlano?.dtFimAtuacao && IPlano.dtFimAtuacao !== "") ? "none" : "inline" }}
                onClick={() => {
                  setEstadoModal(3); // SET O MODO EDIÇÃO
                  setFieldsDetalharEditar(IPlano);
                  // ALTERA CAMPOS DO DATASET PARA REFLETIR O ESTADO DE EDIÇÃO
                  dirigenteExcepcionalPlanosBeneficio.forEach(plano => {
                    if (plano === IPlano) {
                      plano.statusReg = 1;
                      plano.touched = true;
                      plano.emEdicao = estadoModal === 3 ? true : false;
                    } else {
                      plano.emEdicao = false;
                    }
                  })
                  IPlano.emEdicao = true;
                }}
              />

              <DeleteOutlined
                title="Exluir"
                style={{ color: "red", display: (IPlano?.idDirExcepPlanoBeneficio && IPlano?.idDirExcepPlanoBeneficio < 0) ? "inline" : "none" }} // EXCLUSÃO DE REGISTRO SENDO INSERIDO NO PROCESSO DE ALTERAÇÃO. OU SEJA. QUE AINDA NÃO ESTÁ NA BASE
                onClick={() => {
                  setDirigenteExcepcionalPlanosBeneficio(dirigenteExcepcionalPlanosBeneficio.filter((plano) => plano !== IPlano));
                }}
              />
            </div>

            <div style={{ display: (IPlano?.idDirExcepPlanoBeneficio && IPlano?.idDirExcepPlanoBeneficio > 0) && hasPermissao([Papel.DILIC_MASTER]) ? exibirElementoAcaoAlteracao : "none" }}>
              <>
                <PlusSquareFilled
                  title="Desmarcar para exclução/inativação"
                  style={{ color: "blue", display: (IPlano.statusReg === 1) ? "none" : "inline" }}
                  onClick={() => {
                    IPlano.touched = true; // MARCA O REGISTRO ALTERADO.
                    IPlano.statusReg = (IPlano.statusReg === 1 ? 2 : 1); // INVERTE ENTRE 1 (REGISTRO ATUAL ATIVO) E 2 (REGISTRO ATUAL DELETADO)
                    setDirigenteExcepcionalPlanosBeneficio(pre => { //TROCA O REGISTRO DO DATASET PELO REGISTRO EM ALTERAÇÃO
                      return pre.map(plano => {
                        if (plano.idDirExcepPlanoBeneficio === IPlano.idDirExcepPlanoBeneficio) {
                          return IPlano;
                        } else {
                          return plano;
                        }
                      });
                    });
                  }}
                />
              </>

              <>
                <DeleteOutlined
                  title="Marcar para exclução/inativação"
                  style={{ color: "red", display: (IPlano.statusReg === 1) ? "inline" : "none" }}
                  onClick={() => {
                    IPlano.touched = true; // MARCA O REGISTRO ALTERADO.
                    IPlano.statusReg = (IPlano.statusReg === 1 ? 2 : 1); // INVERTE ENTRE 1 (REGISTRO ATUAL ATIVO) E 2 (REGISTRO ATUAL DELETADO)
                    setDirigenteExcepcionalPlanosBeneficio(pre => {
                      return pre.map(plano => {
                        if (plano.idDirExcepPlanoBeneficio === IPlano.idDirExcepPlanoBeneficio) {
                          return IPlano;
                        } else {
                          return plano;
                        }
                      });
                    });
                  }}
                />
              </>
            </div>
          </Space>
      ),
    },
  ];

  const handleCancel = () => {
    setEstadoModal(1); // COLOCA O MODAL EM ESTADO DE INCLUSÃO DE NOVO REGISTRO. MODO PADRÃO
    controleDaGrid("cancelar");
    form.resetFields([
      "cnpbPlanoBeneficio",
      "nmPlanoBeneficio",
      "dtInicioPlano",
      "dtFimPlano",
      "dtFimPlanoNaBase",
    ]);
  };


  const getCnpbPlano = (cnpb: string) => {
    let cnpbLocal = undefined;
    planosBeneficios.forEach((plano) => {
      if (plano.cnpb === cnpb) {
        cnpbLocal = plano.cnpb
      }
    })
    return cnpbLocal;
  }

  const handlerPlanoBeneficio = async (value: any) => {
    form.setFieldsValue({
      "nmPlanoBeneficio": value.children,
      "cnpb": getCnpbPlano(value.key)
    });
  };

  return (
    <>
      <Button
        style={{ display: exibirElementoAcaoAlteracao }}
        id="incluirPlano"
        type="primary"
        shape="round"
        onClick={() => {
          limpaDados();
          setEstadoModal(1); // COLOCA O MODAL EM ESTADO DE INCLUSÃO DE NOVO REGISTRO.
          controleDaGrid("incluirPlano");
        }}
        icon={<PlusOutlined />}
      >
        Incluir Plano de Benefício
      </Button>

      <>
        <Modal title="Incluir Plano de Benefícios" open={exibirModalPlano}
          style={{ top: 20 }}
          destroyOnHidden={true}
          width={700}
          closable={false}
          footer={[
            <Button icon={<CloseOutlined />} shape="round" key="cancelFechar" onClick={handleCancel}>
              {estadoModal === 2 ? "Fechar" : "Cancelar"}
            </Button>,
            <Button icon={<CheckOutlined />} shape="round" style={{ display: estadoModal === 2 ? "none" : "inline" }}
              key="ok" type="primary" onClick={validarPlanoBeneficio}>
              {estadoModal === 3 ? "Alterar" : "Incluir"}
            </Button>,
          ]}
        >
          <Spin spinning={loading} tip={tipLoading}>
            <>
              <Row>
                <Col xs={24} sm={24} >
                  <Form.Item label='Plano de Benefícios'
                    name='nmPlanoBeneficio'
                    labelCol={{ span: 12 }}
                    labelAlign="left"
                    colon={false}
                    rules={[
                      {
                        required: true,
                        message: "O plano de benefícios é obrigatório",
                      },
                    ]}
                  >
                    <Select
                      disabled={manter === 1 ? false : true}
                      style={{ width: 600 }}
                      showSearch
                      filterOption
                      optionFilterProp='children'
                      placeholder='Plano'
                      onChange={(_, index) => {
                        handlerPlanoBeneficio(index);
                      }}
                    >
                      {planosBeneficios?.map((e: IPlanoBeneficio) => (
                        <Option key={e.cnpb} value={e.cnpb}>
                          {e.nome}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col xs={24} sm={8}>
                  <Form.Item label="Data Inicial"
                    name="dtInicioPlano"
                    colon={false}
                    rules={[
                      {
                        required: true,
                        message: "Data inicial obrigatória",
                      },
                      {
                        validator: async (_, dtInicioPlano) => {
                          let dtInicioAtuacao = form.getFieldValue("dtInicioAtuacao");
                          if (dtInicioAtuacao && dtInicioPlano) {
                            dtInicioPlano = dayjs(dtInicioPlano).format("YYYY-MM-DD")
                            dtInicioAtuacao = dayjs(dtInicioAtuacao).format("YYYY-MM-DD")
                            if (dtInicioPlano < dtInicioAtuacao) {
                              return Promise.reject(
                                "A Data Inicial do plano de benefícios não pode ser anterior à Data Inicial de Atuação do Dirigente Expecional."
                              );
                            }
                          }
                        },
                      },
                    ]}
                  >
                    <DatePicker
                      disabled={manter === 1 ? false : true}
                      format={"DD/MM/YYYY"}
                      style={{ width: "100%" }}
                      placeholder="Selecionar Data"
                      disabledDate={disabledDate}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={8}>
                  <Form.Item label="Data Final"
                    name="dtFimPlano"
                    colon={false}
                    rules={[
                      {
                        validator: async (_, endDatetime) => {
                          let startDatetime = form.getFieldValue("dtInicioAtuacao");
                          if (startDatetime && endDatetime) {
                            endDatetime = dayjs(endDatetime).format("YYYY-MM-DD")
                            startDatetime = dayjs(startDatetime).format("YYYY-MM-DD")
                            if (endDatetime < startDatetime) {
                              return Promise.reject(
                                "A Data Final do plano de benefícios não pode ser anterior à Data Inicial de Atuação do Dirigente Excepcional."
                              );
                            }
                          }
                        },
                      },
                      {
                        validator: async (_, endDatetime) => {
                          let dtInicioPlano = form.getFieldValue("dtInicioPlano");
                          if (dtInicioPlano && endDatetime) {
                            endDatetime = dayjs(endDatetime).format("YYYY-MM-DD")
                            dtInicioPlano = dayjs(dtInicioPlano).format("YYYY-MM-DD")
                            if (endDatetime < dtInicioPlano) {
                              return Promise.reject(
                                "A Data Final do plano de benefícios não pode ser anterior à Data Inicial do plano de benefícios."
                              );
                            }
                          }
                        },
                      },
                    ]}
                  >
                    <DatePicker
                      format={"DD/MM/YYYY"}
                      style={{ width: "100%" }}
                      placeholder="Selecionar Data"
                      disabled={manter === 1 ? false : (manter ===2 || manter === 9 ? true : form.getFieldValue("dtFimPlanoNaBase") !== undefined)}
                    />
                  </Form.Item>
                </Col>

              </Row>

            </>
          </Spin>
        </Modal>
      </>

      <Row style={{ display: exibirPlano }}>
        <Col
          xs={24}
          xl={24}
          style={{ paddingLeft: 16, paddingRight: 16, marginBottom: 20 }}
        >
          <Table size="small" showHeader={true} columns={columns} dataSource={dirigenteExcepcionalPlanosBeneficio} pagination={false} />
        </Col>
      </Row>

    </>
  )
};

export default DirigenteExcepcionalPlano;